<template>
  <section class="document-info">
    <h2 v-if="title">Documents</h2>
    <div
      v-if="isEdit"
      class="abs-top-right">
      <v-button
        type="primary"
        :disabled="disabledEdit"
        plain
        @click="() => $emit('edit')">Edit Quote</v-button>
    </div>
    <housemaid-document-info
      v-if="productId == 12"
      :formData="form" />
    <travel-document-info
      v-else-if="productId == 14"
      :formData="form" />
    <decoration-document-info
      v-else-if="productId == 15"
      :formData="form" />
    <student-document-info
      v-else-if="productId == 16"
      :formData="form" />
    <personal-document-info
      v-else-if="productId == 18"
      :formData="form" />
    <homefire-document-info
      v-else-if="productId == 17||productId==20"
      :formData="form" />
    <drone-document-info
      v-else-if="productId==21"
      :formData="form" />
    <sme-document-info
      v-else-if="productId==80&&!isNewSME"
      :form-data="form"></sme-document-info>
    <new-sme-document-info
      v-else-if="isNewSME"
      :form-data="form"></new-sme-document-info>
    <div
      v-else-if="productId == 13"
      class="form-item">
      <div class="form-item tr">
        <span>Renewal Letter（Insurer）</span>
        <file-container
          is-show-detail
          is-viewer
          :fileData="form.renewal_letter_insurer" />
      </div>
      <span >Policyholder HKID</span>
      <file-container :fileData="form.id_type_pic" />
    </div>

    <section
      v-else-if="productId == 22"
      class="document-form sme-container__info sme-container__info-document">
      <div class="box">
        <div class="table">
          <div class="th font-14" >Documents</div>
          <div
            v-if="form.renewal_letter_insurer"
            class="form-item tr">
            <span>Renewal Letter（Insurer）</span>
            <file-container
              is-show-detail
              is-viewer
              :fileData="form.renewal_letter_insurer" />
          </div>
          <div class="form-item tr">
            <span >Policyholder HKID</span>
            <file-container
              is-show-detail
              is-viewer
              :fileData="form.id_type_pic" />
          </div>
        </div>
      </div>
    </section>
    <template v-else>
      <section class="document-form sme-container__info sme-container__info-document">
        <div class="box">
          <div class="table">
            <div class="th font-14" >Documents</div>
            <div
              v-if="form.renewal_letter_insurer"
              class="form-item tr">
              <span>Renewal Letter（Insurer）</span>
              <file-container
                is-show-detail
                is-viewer
                :fileData="form.renewal_letter_insurer" />
            </div>
            <div class="form-item tr">
              <span  v-if="form.cust_typ == 2">Certificate of Incorporation/Business Registration Certificate</span>
              <span v-else>Policyholder HKID</span>
              <file-container
                is-show-detail
                is-viewer
                :fileData="form.id_type_pic" />
            </div>
            <template v-if="!isMotorTrade">
              <div class="form-item tr">
                <span>NCB proof (e.g. Renewal Notice)</span>
                <file-container
                  is-show-detail
                  is-viewer
                  :fileData="form.ncd_proof" />
              </div>
              <div
                class="form-item tr">
                <span>Vehicle Registration Document</span>
                <file-container
                  is-show-detail
                  is-viewer
                  :fileData="form.rgtn_pic" />
              </div>
              <div
                class="form-item tr">
                <span>Vehicle Registration Document with previous owner name / Vehicle Document</span>
                <file-container
                  is-show-detail
                  is-viewer
                  :fileData="form.rgtn_with_owner_pic" />
              </div>
            </template>
            <!--            <div-->
            <!--              v-if="form.cust_typ == 2"-->
            <!--              class="form-item tr">-->
            <!--              <span>Business Registration Certificate</span>-->
            <!--              <file-container-->
            <!--                is-show-detail-->
            <!--                is-viewer-->
            <!--                :fileData="form.br_pic" />-->
            <!--            </div>-->
            <template v-if="isMotorTrade&&!isTPlate||!isMotorTrade">
              <div
                v-if="form.nm_drvr_list && form.nm_drvr_list.length > 0"
                class="tr">
                Insured Driver(s)
              </div>
              <div
                v-for="(item, index) in form.nm_drvr_list"
                :key="index"
              >
                <span class="tr">Driver{{index+1}} {{ item.nm_drvr_lst_nm }} {{ item.nm_drvr_fst_nm }}</span>
                <div class="form-item tr">
                  <span class="label">HKID Card</span>
                  <file-container
                    is-viewer
                    is-show-detail
                    :fileData="driversFileList[index].idType" />
                </div>
                <div class="form-item tr">
                  <span  class="label">{{isHzmb?"Mainland Driver's License File":'Driving Licence'}}</span>
                  <file-container
                    is-viewer
                    is-show-detail
                    :fileData="driversFileList[index].license" />
                </div>
              </div>
            </template>
            <div
              v-if="form.other_file && form.other_file.length > 0"
              class="form-item">
              <div class="tr">Additional Documents</div>
              <div
                v-for="(item, index) in form.other_file"
                :key="index + 'a'"
                class="tr form-item">
                <span>Vehicle Registration Document (Optional)</span>
                <file-container
                  is-viewer
                  is-show-detail
                  :fileData="item" />
              </div>
            </div>
            <!--            <template v-if="inter">-->
            <!--              <h3-->
            <!--                v-if="form.inter_file && form.inter_file.length > 0"-->
            <!--                class="mg-t-15">Internal Documents</h3>-->
            <!--              <div-->
            <!--                v-for="(item, index) in form.inter_file"-->
            <!--                :key="index + 'inter'"-->
            <!--                class="form-item">-->
            <!--                <file-container-->
            <!--                  is-viewer-->
            <!--                  is-show-detail-->
            <!--                  :fileData="item" />-->
            <!--              </div>-->
            <!--            </template>-->

            <div
              v-if="form.inter_file && form.inter_file.length > 0"
              class="form-item">
              <div class="tr">Internal Documents</div>
              <div class="tr form-item">
                <file-container
                  v-for="(item, index) in form.other_file"
                  :key="index + 'inter'"
                  is-viewer
                  is-show-detail
                  :fileData="item"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </section>
</template>
<script>
import FileContainer from '@/views/components/file-container'
import HousemaidDocumentInfo from '@/views/components/modules/housemaid/housemaid-document-info'
import DecorationDocumentInfo from '@/views/components/modules/decoration/decoration-document-info'
import HomefireDocumentInfo from '@/views/components/modules/homefire/homefire-document-info'
import TravelDocumentInfo from '@/views/components/modules/travel/travel-document-info'
import DroneDocumentInfo from '@/views/components/modules/drone/document-info'
import StudentDocumentInfo from '@/views/components/modules/student/student-document-info'
import PersonalDocumentInfo from '@/views/components/modules/personal/personal-document-info'
import smeDocumentInfo from '@/views/components/modules/sme/sme-document-info'
import NewSmeDocumentInfo from '@/views/sme/components/documentInfo'

export default {
  name: 'DocumentInfo',
  components: {
    FileContainer,
    HousemaidDocumentInfo,
    DecorationDocumentInfo,
    HomefireDocumentInfo,
    TravelDocumentInfo,
    StudentDocumentInfo,
    PersonalDocumentInfo,
    smeDocumentInfo,
    DroneDocumentInfo,
    NewSmeDocumentInfo
  },
  props: {
    form: {
      type: Object,
      default: () => ({
        nm_drvr_list: [],
        other_file: [],
        inter_file: []
      })
    },
    inter: {
      type: Boolean,
      default: false
    },
    disabledEdit: {
      type: Boolean,
      default: false
    },
    title: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    productId() {
      return this.form.product_id
    },
    driversFileList() {
      let nm_drvr_list = this.form.nm_drvr_list
      return nm_drvr_list.reduce((result, item) => {
        result.push({
          idType: {
            url: item.nm_drvr_id_type_pic_url,
            thumb_url: item.nm_drvr_id_type_pic_thumb_url,
            id: item.nm_drvr_id_type_pic_path_id,
            path: item.nm_drvr_id_type_pic_path
          },
          license: {
            url: item.nm_drvr_licence_pic_url,
            thumb_url: item.nm_drvr_licence_pic_thumb_url,
            id: item.nm_drvr_licence_pic_path_id,
            path: item.nm_drvr_licence_pic_path
          }
        })
        return result
      }, [])
    },
    isEdit(){
      const {stts} = this.form
      return stts < 401
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id ==13
    },
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id ==15
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

.document-info {
    position: relative;
}
</style>
